import getFromCdn from '@anm/helpers/getFromCdn';
import noop from '@anm/helpers/noop';
import React, { useEffect, FC } from 'react';

import { BrokenVideoStatusCodes, VideoPlayerCallbacks, VideoStatusCode } from '../../types';
import Logo from '../Logo';

import { ContentWrapper, ErrorMessage, Icon, Wrapper } from './Wrapper';
import { useBrokenPlayerSize } from './hooks';

type BrokenPlayerProps = {
  videoId: string;
  errorCode: BrokenVideoStatusCodes;
} & VideoPlayerCallbacks;

const getErrorMessage = (code: BrokenVideoStatusCodes, videoId: string) =>
  ({
    [VideoStatusCode.not_found]: 'Video not found',
    [VideoStatusCode.private]: 'Video is not embedded',
    [VideoStatusCode.blocked]: 'This video is blocked',
    [VideoStatusCode.processingError]: `Error processing this video ${videoId}. Please contact support at support@wave.video`,
    [VideoStatusCode.default]: 'Video unavailable',
    [VideoStatusCode.codecErorr]: 'Video cannot be displayed in browser'
  }[code]);

const BrokenPlayer: FC<BrokenPlayerProps> = ({ videoId, errorCode, onInit = noop }) => {
  const [viewHeight, wrapperRef] = useBrokenPlayerSize();

  useEffect(() => {
    onInit();
  }, []);

  return (
    <Wrapper ref={wrapperRef} {...{ ...(viewHeight && { height: viewHeight }) }}>
      <Logo />
      <ContentWrapper>
        <Icon src={getFromCdn('images/icons/no-video-icon.svg')} alt="Wave.video" />
        <ErrorMessage>{getErrorMessage(errorCode, videoId)}</ErrorMessage>
      </ContentWrapper>
    </Wrapper>
  );
};

export default BrokenPlayer;
